module.exports = __webpack_public_path__ + "fonts/fddbcb901207ab732832c5da3add7ebb.svg";